// extracted by mini-css-extract-plugin
export default {"root":"tM4vDBog","closeButton":"WHXvpbfM","container":"CzGa2Au9","editor":"nUL5Oi5Q","control":"QYb2TPPF"};